module.exports = __webpack_public_path__ + "static/media/dk_1N.ee03da4f.png";